var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarraOuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 980,
    height: 20,
    viewBox: "0 0 980 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.654 20H0V0H318.959L312.654 20Z",
    fill: "#FFCD07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M645.33 20H326.186L328.344 13.134L332.479 0H652.161L645.33 20Z",
    fill: "#FFCD07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M667.305 -2.73331e-05L979.959 0L979.959 20L661 20L667.305 -2.73331e-05Z",
    fill: "#FFCD07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarraOuro);
export default __webpack_public_path__ + "static/media/barra-ouro.9a9b130cf897595a23e1771cfc4769ba.svg";
export { ForwardRef as ReactComponent };